import pick from 'lodash/pick';
import reduce from 'lodash/reduce';

import { downloadCsv } from '@shared/utils';

export const createCsvContent = (items, opts = {}) => {
  const { newlineSeparator = '\r\n' } = opts;

  return reduce(
    items,
    (content, item) => {
      const finalLine = reduce(
        item,
        (line, value) => {
          const lineContent =
            typeof value === 'string' && value.includes(',')
              ? `"${value}"`
              : value;
          return line === '' ? lineContent : `${line},${lineContent}`;
        },
        '',
      );

      return `${content}${finalLine}${newlineSeparator}`;
    },
    '',
  );
};

/*
 * headers - An object where the key is the field name and the value
 *           is the header text. These should match the order you want
 *           the columns exported.
 * items - The list of objects to be exported
 * fileName - A string that will be the title of the downloaded file
 */
export const exportCsvFile = (headers, items, fileName) => {
  const exportedItems = [
    headers,
    ...items.map(item => pick(item, Object.keys(headers))),
  ];
  const csvContent = createCsvContent(exportedItems);

  return downloadCsv(fileName, csvContent);
};
